class HeaderMenuItem extends HTMLElement {
  constructor() {
  	super();
   	this.detailsToggle = this.querySelector('details');
    this.detailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }
  
   onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }
  
  close() {
    this.detailsToggle.removeAttribute('open');
   
  }
	
}

customElements.define('header-menu-item', HeaderMenuItem);
